import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DemoAudio from "../../../assets/demoAudio.mp3";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import { Box, Button, CircularProgress } from "@mui/material";

import AutohideSnackbar from "../../../components/AutohideSnackbar";
import axiosInstance from "../../../services/axiosInterceptors";
import { palette, theme as colorTheme } from "../../../Convoze.theme";



const primary = colorTheme('palette', 'primary').value;
const pop = colorTheme('palette', 'pop').value;
const positive = colorTheme('palette', 'positive').value;
const neutral = colorTheme('palette', 'neutral').value;
const negative = colorTheme('palette', 'negative').value;


const DemoAudioFile = ({
  disable,
  disableDefaultAudio,
  setDisableDefaultAudio,
}) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  // State management
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
  });

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("files", file);

    try {
      const response = await axiosInstance.post(
        apiEndPointsConfig?.demoUploadFile,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response?.data?.status?.code === 200) {
        navigate("/demo/audio/transcript");
      } else {
        throw new Error(response?.data?.status?.value);
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.response?.data?.status?.value || error?.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleUploadClick = async () => {
    setLoading(true);
    try {
      const response = await fetch(DemoAudio);
      const blob = await response.blob();
      const file = new File([blob], "demoAudio.mp3", { type: "audio/mpeg" });
      await uploadFile(file);
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Error fetching the demo audio file.",
      });
      setLoading(false);
    }
  };

  return (
    <Box display="flex" justifyContent="center" width="100%">
      <Button
        onClick={handleUploadClick}
        loading={loading}
        disabled={disable || loading || disableDefaultAudio}
        variant="contained"
        sx={{
          bgcolor: disable ? negative : positive,
          color: "white",
          textTransform: "none",
          fontSize: "1rem",
          height: "40px",
          borderRadius: "12px",
          "&:hover": {
            bgcolor: primary,
          },
        }}
      >
        {loading ? (
          <>
            Uploading &nbsp; <CircularProgress size={20} />
          </>
        ) : (
          "Use Default Audio"
        )}
      </Button>
      <AutohideSnackbar
        message={snackbar?.message}
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </Box>
  );
};

export default DemoAudioFile;
